import { gql } from '@apollo/client'

export const GET_ARTICLE = gql`
  query article($id: String!) {
    article(id: $id) {
      _id
      name
      content
    }
  }
`

export const GET_ARTICLES = gql`
  query articles($affiliateId: String) {
    articles(affiliateId: $affiliateId) {
      _id
      name
      content
    }
  }
`
